import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingHeicToJpegConfig } from '@/data/landingConfig/landingHeicToJpegConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_HeicToJpeg } from './schemaObject';

interface Props {}
const HeicToJpegConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_HeicToJpeg} />
			<LandingTemplate
				data={landingHeicToJpegConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default HeicToJpegConverter;
